module.exports = __webpack_public_path__ + "img/checkmark.9603067e.png";